export { HopperOctopusConfiguration } from "./octopus/hopperOctopusConfiguration";
export { HopperOctopusOptions } from "./octopus/hopperOctopusOptions";
